import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import LoginPage from "../pages/login/LoginPage";
import { HelpPageRouter } from "./HelpPageRouter";

export const LoginRouter = () => {
  return (
    <Routes>
      <Route path="help/*" element={<HelpPageRouter />} />

      <Route path="login" element={<LoginPage />} />

      <Route path="*" element={<Navigate to="login" />} />
    </Routes>
  );
};
